import { observer } from 'mobx-react-lite'
import React, { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { type ActionItem, Button, ContainerHeader } from 'shared/ui'
import type { PageLayoutStore } from 'shared/layout'
import { LINK_TRIGGERS_HELP_GUIDE } from 'shared/constants/links'
import { TriggersRoutes } from 'entities/ExportRouters'

type ITriggersHeaderProps = {
  title: string
  pageLayoutStore: PageLayoutStore
  isTriggersEmpty: boolean
}

export const TriggersHeader = observer(
  ({ title, pageLayoutStore, isTriggersEmpty }: ITriggersHeaderProps) => {
    const { titleIconProps, headerMenuTooltipIconProps, headerMenuIconAction } = pageLayoutStore

    const navigate = useNavigate()
    const onCreateClick = () => {
      navigate(`/${TriggersRoutes.root}/${TriggersRoutes.create}`)
    }

    const actions: ActionItem[] = useMemo(() => {
      if (isTriggersEmpty) {
        return []
      }
      return [
        {
          iconButtonComponent: (
            <Button
              tag='a'
              text='Help guide'
              size='medium'
              contained='secondary'
              iconProps={{ icon: 'info' }}
              href={LINK_TRIGGERS_HELP_GUIDE}
              style={{ textDecoration: 'none' }}
              target='_blank'
              rel='noreferrer'
            />
          ),
        },
        {
          iconButtonComponent: (
            <Button
              text={'New trigger'}
              onClick={onCreateClick}
              iconProps={{ icon: 'add' }}
              size={'medium'}
            />
          ),
        },
      ]
    }, [isTriggersEmpty])

    return (
      <ContainerHeader
        height={72}
        title={title}
        titleVariant={'heading-md'}
        titleIconProps={titleIconProps}
        actionIconTooltipProps={headerMenuTooltipIconProps}
        titleIconAction={headerMenuIconAction}
        paddingLeft={20}
        paddingRight={20}
        actions={actions}
        actionsGap={8}
      />
    )
  }
)
